import { profileType } from "@utils/enum";

export const SEARCH_TYPE_MAPPING = {
  allCategory: "All Categories",
  product_description: "Product",
  importers: "Consignee",
  product_hscode: "HS Code",
  exporters: "Shipper",
  logistics: "Logistics",
  port: "Port",
  ports: "Ports",
  vocc: "VOCC",
  nvocc: "NVOCC",
  port_of_lading: "Port of Lading",
  port_of_unlading: "Port of Unlading",
  chemical_description: "Chemical",
  product_category: "Product Category",
  entire_bill_of_lading: "All Categories",
  trade_lane: "Trade Lane",
};

export const suggestionsKeyLabel = {
  product_description: "Product",
  product_hscode: "HS Code",
  exporters: "Shipper",
  importers: "Consignee",
  chemical_description: "Chemical",
  logistics: "Logistic",
  ports: "Port",
  product_category: "Product Category",
};
export const PillColor = {
  product_description: "#e30c0c",
  importers: "#2a3791",
  exporters: "#07710b",
  logistics: "#178add",
  product_hscode: "#e30c0c",
  product_category: "#e30c0c",
  chemical_description: "#e3730c",
  port: "#de1368",
  ports: "#de1368",
  vocc: "#178add",
  nvocc: "#178add",
  port_of_lading: "#de1368",
  port_of_unlading: "#de1368",
};

export const match_type_options = [
  { value: "contains", label: "Contains" },
  { value: "exact", label: "Exact Phrase" },
];
export const searchTypeCustomStyles = {
  control: (base) => ({
    ...base,
    height: 20,
    minWidth: 125,
    minHeight: 20,
    backgroundColor: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    border: "none",
    boxShadow: "none",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    fontWeight: 500,
    padding: "4px 8px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    height: 20,
    padding: "0px 8px 0px 0px",
    justifyContent: "center !important",
    alignItems: "center !important",
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: "0",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "" : null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "rgba(111, 8, 241, 0.1)",
    },
    margin: "4px 0",
  }),
};

export const profileTypeHandler = (searchUrlParams) => {
  if (searchUrlParams.includes("redirectingFrom=trade_region")) {
    return profileType.tradeLanes;
  } else if (searchUrlParams.includes("redirectingFrom=port")) {
    return profileType.ports;
  } else if (searchUrlParams.includes("logistics")) {
    return profileType.logistics;
  } else {
    return profileType.company;
  }
};
